import { Slot } from '@radix-ui/react-slot';
import * as React from 'react';
import { tv, type VariantProps } from 'tailwind-variants';

const badgeVariants = tv({
  base: 'inline-flex items-center justify-center rounded-md border px-2 py-0.5 text-xs font-medium w-fit whitespace-nowrap shrink-0 [&>svg]:size-3 gap-1 [&>svg]:pointer-events-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] transition-[color,box-shadow] overflow-hidden',
  variants: {
    variant: {
      default:     'border-transparent bg-primary text-primary-foreground [a&]:hover:bg-primary/90',
      secondary:   'border-transparent bg-secondary text-secondary-foreground [a&]:hover:bg-secondary/90',
      destructive: 'border-transparent bg-destructive text-white [a&]:hover:bg-destructive/90 focus-visible:ring-destructive/20 dark:focus-visible:ring-destructive/40 dark:bg-destructive/60',
      outline:     'text-foreground [a&]:hover:bg-accent [a&]:hover:text-accent-foreground',
      muted:       'border-transparent bg-muted text-muted-foreground',
      success:     'border-success/30 bg-success/15 text-success',
      warning:     'border-warning/30 bg-warning/15 text-warning',
      info:        'border-info/30 bg-info/15 text-info',
    },
  },
  defaultVariants: {
    variant: 'default',
  },
});

function Badge({
  className,
  variant,
  asChild = false,
  ...props
}: React.ComponentProps<'span'> &
  VariantProps<typeof badgeVariants> & { asChild?: boolean }) {
  const Comp = asChild ? Slot : 'span';
  return (
    <Comp
      data-slot="badge"
      className={badgeVariants({ variant, class: className })}
      {...props}
    />
  );
}

export { Badge, badgeVariants };
